import React, {Component} from 'react';
import {Button, Form, Grid, Header, Image, Menu, Segment,Label} from 'semantic-ui-react';
import * as profileImage from '../../../assets/profile_image_placeholder.png'
import {getCurrentUserProfile, updateProfileById} from "../../../data/user_api";
import {CLERK_API_URL} from "../../../constants/api_routes";
import AvailLeave from "./avail_leave";
import Loader from '../../universal/loader';
import WeeklyAvailability from './weekly_availability';
import PushNotificationWindow from '../../dashboard/push_notification_window';

class ClerkProfile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: {},
            action: 'view',
            profileId: JSON.parse(localStorage.getItem('user'))['profile_id'],
            isLoading: true,
            isError: false,
            message: ''
        }
    }

    componentDidMount() {
        this.getProfileData(CLERK_API_URL, this.state.profileId).then((response) => {
            this.setState({isLoading: false})
        }).catch(() => {
            this.setState({isError: true, message: "Something Went wrong. Try again Later"})
        })
    };

    getProfileData = async (url, id) => {
        this.setState({ isLoading: true})
        const {profileData} = await getCurrentUserProfile(url, id);
        this.setState({profile: profileData['clerk_profile'],isLoading:false});
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        this.setState({isLoading:true})
        updateProfileById(CLERK_API_URL, this.state.profileId, formData).then((response) => {
            this.setState({ message: response.statusMessage });
            this.getProfileData(CLERK_API_URL, this.state.profileId)
        });
        this.setState({action: 'view'});
    };

    updateProfile = (currentEditingUser) => {
        return (<div>
            <div>
                <Segment>
                    <Header as='h2' textAlign='center'>
                        Update Profile
                    </Header>
                    {this.state.isLoading && <Loader/>}
                    {!this.state.isLoading && <Form onSubmit={this.handleSubmit}>
                        <Grid centered columns={2} stackable>
                            <Grid.Column width={8}>
                                <Grid.Row>
                                    <Header color='blue'>
                                        Profile Details
                                    </Header>
                                    <p></p>
                                    <p style={{fontWeight: 600, fontSize: '1.3rem'}}>Email: <span
                                        style={{fontWeight: 200}}>{currentEditingUser.email}</span>
                                    </p>
                                    <Form.Input label='Name' fluid icon='user' iconPosition='left' placeholder='Name'
                                                type='text' name="name" defaultValue={currentEditingUser.name}
                                                required/>
                                    <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                                placeholder='328659286'
                                                type='text' name="mobile_number"
                                                defaultValue={currentEditingUser['mobile_number']}
                                                required/>
                                    <div className='clearfix-placeholder'>

                                    </div>
                                </Grid.Row>
                                <Grid.Row width={8}>
                                    <Header color='blue'>
                                        Address Details
                                    </Header>
                                    <p></p>
                                    <Form.Input label='Address Line 1' fluid
                                                placeholder='Street'
                                                type='street view'
                                                name="line1"
                                                defaultValue={currentEditingUser.line1}
                                                required/>
                                    <Form.Input label='Address Line 2' fluid
                                                placeholder='Landmark'
                                                type='street view'
                                                name="line2"
                                                defaultValue={currentEditingUser.line2}
                                                required
                                    />
                                    <Form.Group widths={2}>
                                        <Form.Input label='Locality' fluid
                                                    placeholder='Region'
                                                    type='text'
                                                    name="locality"
                                                    defaultValue={currentEditingUser.locality}
                                        />
                                        <Form.Input label='City' fluid
                                                    placeholder='City'
                                                    type='text'
                                                    name="city"
                                                    defaultValue={currentEditingUser.city}
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Input label='Country' fluid
                                                    placeholder='Country'
                                                    type='text'
                                                    name="country"
                                                    defaultValue={currentEditingUser.country}
                                        />
                                        <Form.Input label='Post Code' fluid
                                                    placeholder='C2PN57'
                                                    type='text'
                                                    name="postcode"
                                                    defaultValue={currentEditingUser.postcode}
                                                    required
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Input label='Date of Birth' fluid
                                                    placeholder='Date of Birth'
                                                    type='text'
                                                    name="dob"
                                                    defaultValue={currentEditingUser.dob}
                                        />
                                        <Form.Input label='Driving License Number' fluid
                                                    placeholder='Driving Licence Number'
                                                    type='text'
                                                    name="licenseno"
                                                    defaultValue={currentEditingUser.licenseno}
                                        />
                                    </Form.Group>
                                    <Form.Group widths={2}>
                                        <Form.Input label='Emergency Contact Name / Relation' fluid
                                                    placeholder='Emergency Contact Name / Relation'
                                                    type='text'
                                                    name="emergencyname"
                                                    defaultValue={currentEditingUser.emergencyname}
                                        />
                                        <Form.Input label='Emergency Contact Number' fluid
                                                    placeholder='Emergency Contact Number'
                                                    type='text'
                                                    name="emergencytelephone"
                                                    defaultValue={currentEditingUser.emergencytelephone}
                                                    required
                                        />
                                    </Form.Group>
                                </Grid.Row>
                                <Grid.Row>
                                <Segment style={{height: '100%'}}>
                                    <Header>Update Documents</Header>
                                    <Form.Input label="Insurance" type='file' accept="image/*" name="insurance"/>
                                    <Form.Input label='License Document' type='file' accept="image/*" name="license"/>
                                    <Form.Input label='Signature' type='file' accept="image/*" name="sign"/>
                                </Segment>
                                </Grid.Row>
                                <Grid.Row>
                                    <div className="submit-buttons">
                                        <Button primary fluid>Update User</Button>
                                    </div>
                                </Grid.Row>
                            </Grid.Column>
                        </Grid>
                    </Form>}
                </Segment>
            </div>
        </div>);
    };

    render() {
        const user = this.state.profile;
        return (<div>
            {this.state.isLoading && <Loader/>}
            {this.state.action === 'view' && !this.state.isLoading && <Grid centered columns={2}>
                <Grid.Column>
                    <Segment>
                        <Image src={profileImage} width='30%' centered/>
                        <Header as='h2' textAlign='center'> {this.state.profile.name} </Header>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Email: <span
                                        style={{fontWeight: 200}}>{user.email}</span></p>
                                    <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Mobile Number: <span
                                        style={{fontWeight: 200}}>{user['mobile_number']}</span></p>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <div style={{fontWeight: 400, fontSize: '1.2rem'}}>
                                        <span style={{fontWeight: 600, fontSize: '1.3rem'}}>Address</span>
                                        <p></p>
                                        <p>
                                            {user.line1} , {user.line2},
                                        </p>
                                        <p>
                                            {user.locality},{user.city},
                                        </p>
                                        <p>
                                            {user.country},{user.postcode}
                                        </p>
                                    </div>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Date of Birth: <span
                                        style={{fontWeight: 200}}>{user.dob}</span></p>
                                        <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Driving License No.<span
                                        style={{fontWeight: 200}}>{user.licenseno}</span></p>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Emergency Contact Name/Relation<span
                                        style={{fontWeight: 200}}>{user.emergencyname}</span></p>
                                        <p style={{fontWeight: 600, fontSize: '1.2rem'}}>Emergency Contact Number<span
                                        style={{fontWeight: 200}}>{user.emergencytelephone}</span></p>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                <Button primary onClick={(e) => {
                            this.setState({action: 'editing'})
                        }}>Update My Details</Button>
                        <Button secondary onClick={(e) => {
                            this.setState({action: 'leave'})
                        }}>Mark Leave/Availability</Button>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column><PushNotificationWindow/></Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={16}>
                                    <Header content="My Documents" textAlign="left"/>
                                    <Grid textAlign='center' columns={3} style={{marginTop: 0, marginBottom: '1em'}}>
                                        <Grid.Column>
                                            <Label>Insurance</Label>
                                            <p/>
                                            {user.insurance ?
                                              <Image as='a' target='_blank' src={user.insurance} href={user.insurance} />: <div>No Insurance Uploaded</div>}
                                        </Grid.Column>
                                        <Grid.Column>
                                        <Label>License</Label>
                                        <p/>
                                            {user.license ?    <Image as='a' target='_blank' src={user.license} href={user.licence} />: <div>No Licence Uploaded</div>}
                                        </Grid.Column>
                                        <Grid.Column>
                                        <Label>MOT Copy</Label>
                                        <p/>
                                            {user.sign ?  <Image as='a' target='_blank' src={user.sign} href={user.sign} />: <div>No MOT Copy Uploaded</div>}
                                        </Grid.Column>
                                    </Grid>
                                </Grid.Column>
                            </Grid.Row>

                        </Grid>
                    </Segment>
                    <Grid.Row>
                        <Grid.Column centered width={16}>
                            <WeeklyAvailability callbackFn={() => { this.getProfileData(CLERK_API_URL, this.state.profileId) }} clerkData={this.state.profile}></WeeklyAvailability>
                        </Grid.Column>
                    </Grid.Row>

                </Grid.Column>
            </Grid>
            }
            {this.state.action === 'editing' && this.updateProfile(user)}
            {this.state.action === 'leave' && <AvailLeave clerkId={this.state.profileId}/>}
        </div>);
    }
}

export default ClerkProfile;


// WEBPACK FOOTER //
// ./src/views/user/clerk/profile.js